// Import global functions from functions.js
const { initMap, initDatepicker, initDatepickerYear, initSignaturePad, checkCookies, checkScroll, initColor, isInStandaloneMode } = require('./functions.js') ;
// Import survey function from survey.steps.js
const { initSurveySteps, validateFieldsByYear } = require('../functions/survey.steps');

/**
 * Show Page
 */
function showPage(){
	
	if (window.clinic) {
		initColor(window.clinic);
	}
	checkScroll();
	initMap();
	isInStandaloneMode();
	if ($('.survey-page').length > 0) {
		initSurveySteps();
		validateFieldsByYear();
	}
	if ($('.owl-carousel').length > 0) {

		$('.owl-carousel.testimonials').owlCarousel({
			nav:true,
			loop:true,
			margin:10,
			responsiveClass:true,
			responsive:{
				0:{
					items:1,
					margin:5
				},
				768:{
					items:2
				},
				1200:{
					items:3
				}
			}
		});

		$('.owl-carousel.results, .owl-carousel.steps').owlCarousel({
			nav:true,
			margin:10,
			responsiveClass:true,
			responsive:{
				0:{
					items:1,
					margin:5
				},
				768:{
					items:2
				},
				1200:{
					items:3
				}
			}
		});

		$('.owl-carousel.teams').owlCarousel({
			nav:true,
			margin:10,
			responsiveClass:true,
			responsive:{
				0:{
					items:1,
					margin:5
				},
				900:{
					items:2
				},
				1800:{
					items:3
				}
			}
		});
		
	}
	//Append Map to Section
	if($('#map_canvas').length){
		$('#map_canvas').appendTo('.map_canvas');
	}
	setTimeout(function() {
		initDatepicker();
		initDatepickerYear();
		initSignaturePad();
		checkCookies();
		//Select all input of QM to test
		//$('input[type="radio"]').attr('checked', 'checked');
		$('body').removeClass('loading');
	}, 1000);

}

module.exports = {
	showPage
};